// ..........
export const NAVIGATOR_CONTANTS_DATA = {
    Bookkeeping_DescriptioDetails: {
        heading: 'Description',
        para: "Bookkeeping is the process of recording financial transactions related to a business. It involves systematically recording, classifying, and summarizing financial data to provide accurate and up-to-date information about a business's financial health.",
    },

    Bookkeeping_KeyPoints: {
        heading: 'Key functions of bookkeeping include:',
        points: [
            'Recording financial transactions: This involves accurately logging all income and expenses.',
            'Organizing financial data: Categorizing transactions into appropriate accounts (e.g., accounts receivable, accounts payable, inventory).',
            'Reconciling bank accounts: Ensuring the accuracy of bank statements and identifying discrepancies.',
            'Generating financial reports: Creating financial statements such as income statements, balance sheets, and cash flow statements.',
            'Preparing for tax filing: Gathering financial data for tax preparation.',
        ],
    },

    Bookkeeping_listItem: {
        displayHeading: 'Bookkeeping',
        photoURL: '/images/avatars/avatar_2.jpg',
        isCompleted: false,
    },

    Bookkeeping_checkInputList: [
        {
            name: 'accounts-payable',
            label: 'Accounts payable',
        },
        {
            name: 'accounts-receivable',
            label: 'Accounts receivable',
        },
        {
            name: 'payroll',
            label: 'Payroll',
        },
        {
            name: 'tax-preparation',
            label: 'Tax preparation',
        },
    ],

    Bookkeeping_names: ['Oliver Hansen', 'Van Henry', 'April Tucker', 'Ralph Hubbard', 'Omar Alexander', 'Carlos Abbott', 'Miriam Wagner', 'Bradley Wilkerson', 'Virginia Andrews', 'Kelly Snyder'],

    Landing_DescriptioDetails: {
        heading: 'Welcome to the Business Navigator',
        subHeading: 'Your roadmap to success',
        intro: 'Explore the path, then make it your own.',
        para: `We’ve helped hundreds of thousands of entrepreneurs set up their businesses, and we get the same question over and over—now what?`,
        para1: `We built the Business Navigator to take the guesswork out of entrepreneurship. It compiles the most common and helpful steps in starting and running a business—organized into seven essential categories that reflect the real-world journey of business ownership.`,
        para2: `Think of the Navigator as a flexible roadmap: it shows what’s possible, so you can choose what’s relevant based on your goals, timing, and business model. As you explore, you can add tasks directly to your personalized business checklist and get started on charting your path to success.`,
        buttonText:"Take a tour"
    },

    LineOfCreadit_DescriptioDetails: {
        heading: 'Description',
        para: 'Loan from a bank or other financial institution that the borrower can draw on repeatedly, up to a certain pre-approved amount, and that has no fixed end date for full repayment.',
    },

    LineOfCreadit_listItem: {
        displayHeading: 'Open a line of credit',
        photoURL: '/images/avatars/avatar_2.jpg',
        para: '3/3 completed',
        isCompleted: false,
    },

    // LLC Setup

    LLC_SETUP_DescriptioDetails: {
        heading: 'Description',
        para: 'Purchasing a domain is a foundational step in building a strong online presence and can provide numerous long-term benefits for both individuals and businesses.',
    },
    LLC_SETUP_BenifitsDetails: {
        heading: 'Benifits',
        para: 'Professional Image: Having a custom domain, such as www.yourbusiness.com, gives your business a professional appearance and can enhance credibility.',

        points: [
            'Brand Recognition: A unique domain name can help establish and reinforce your brand identity.',
            'Memorability: A custom domain is easier for customers to remember and return to, compared to a generic URL.',
        ],
    },
    LLC_SETUP_listItem: {
        displayHeading: 'LLC Setup',
        email: 'demo@minimals.cc',
        photoURL: '/images/avatars/avatar_2.jpg',
        para: '3/3 completed',
        isCompleted: true,
    },

    BookingAccount_DescriptioDetails: {
        heading: 'Description',
        para: 'Opening a business bank account is a crucial step in managing your business finances effectively. Establishing a dedicated business bank account is essential for effectively managing and growing your business finances. By segregating business transactions from personal expenses, entrepreneurs can simplify bookkeeping, streamline tax preparation, and enhance financial oversight.',
    },
    BookingAccount_listItem: {
        displayHeading: 'Open a bank account',
        photoURL: '/images/avatars/avatar_2.jpg',
        para: '3/3 completed',
        isCompleted: false,
    },
};
